import { OnInit, TemplateRef } from '@angular/core';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EntriesService } from '../../../services/entries.service';
import { EventsService } from '../../../services/events.service';
import { COURSE_DECLARATION_LABELS } from '../../../constants/course-declaration-labels';
import { AddEditCommentComponent } from '../../modals/actions/add-edit-comment/add-edit-comment.component';
import { AddEditEnquiryComponent } from '../../modals/actions/add-edit-enquiry/add-edit-enquiry.component';
import { EntrySamplingRequestComponent } from '../../modals/actions/entry-sampling-request/entry-sampling-request.component';
import { EntryNonRunnerComponent } from '../../modals/actions/entry-non-runner/entry-non-runner.component';
import { EntryWithdrawnComponent } from '../../modals/actions/entry-withdrawn/entry-withdrawn.component';
import { EntryJockeyChangeComponent } from '../../modals/actions/entry-jockey-change/entry-jockey-change.component';
import { JockeyChangeHistoryComponent } from '../../modals/jockey-change-history/jockey-change-history.component';
var RaceEntryComponent = /** @class */ (function () {
    function RaceEntryComponent(modalService, notification, entriesService, eventsService) {
        var _this = this;
        this.modalService = modalService;
        this.notification = notification;
        this.entriesService = entriesService;
        this.eventsService = eventsService;
        this.entry = null;
        this.actions = {
            none: false,
            enquiry: true,
            comment: true,
            sampling: true,
            jockeyChange: true,
            jockeyChangeHistory: true,
            nonRunner: true,
            withdrawn: true,
        };
        this.even = false;
        this.odd = false;
        this.first = false;
        this.last = false;
        this.borderTop = false;
        this.borderBottom = false;
        this.fullTextModalTitle = '';
        this.fullTextModalBody = '';
        this.reveal = false;
        this.loadOldComments = function (horseId) {
            _this.meta.previousRpcComment.loading = true;
            _this.entriesService.getEntryOldComments(horseId, true, moment(_this.meta.raceDate).subtract(1, 'days').format('YYYYMMDD')).subscribe(function (res) {
                if (res.data.length) {
                    _this.entry.mostRecentRPCText = res.data[0].rpcComments.map(function (rpcComment) { return rpcComment.racePerformanceComment; }).join(', ');
                    _this.entry.mostRecentRPCDate = res.data[0].updatedAt;
                }
                _this.meta.previousRpcComment.loading = false;
            }, function (err) {
                _this.notification.error("Could't get the Entry most recent RPC: " + _this.eventsService.getApiErrorMessage(err), 'Error!');
                _this.meta.previousRpcComment.loading = false;
            });
        };
        this.loadOldEnquiries = function (horseId) {
            _this.meta.previousEnquiry.loading = true;
            _this.entriesService.getEntryOldEnquiries(horseId, moment(_this.meta.raceDate).subtract(1, 'days').format('YYYYMMDD')).subscribe(function (res) {
                if (res.data.length) {
                    _this.entry.mostRecentEnquiryText = res.data[0].offence.offence;
                    _this.entry.mostRecentEnquiryDate = res.data[0].racedate || res.data[0].date;
                }
                _this.meta.previousEnquiry.loading = false;
            }, function (err) {
                _this.notification.error("Could't get the Entry most recent Enquiry: " + _this.eventsService.getApiErrorMessage(err), 'Error!');
                _this.meta.previousEnquiry.loading = false;
            });
        };
        this.loadTodayComments = function (horseId) {
            _this.meta.todayComments.loading = true;
            var todayCommentsRequest = _this.entriesService.getEntryTodayComments(horseId, false, moment(_this.meta.raceDate).format('YYYYMMDD'), moment(_this.meta.raceDate).format('YYYYMMDD'));
            todayCommentsRequest.subscribe(function (results) {
                // separate rcp comments from the non-rpc
                _this.entry.rpcComments = results['data'].filter(function (c) { return c.commentType === 'rpc'; });
                _this.entry.comments = results['data'].filter(function (c) { return c.commentType === 'other'; });
                // Process RPCs
                if (_this.entry.rpcComments.length) {
                    _this.entry.todayCommentText = _this.entry.rpcComments[0]
                        .rpcComments.map(function (rpcComment) { return rpcComment.racePerformanceComment; }).join(', ');
                    _this.entry.todayCommentDate = _this.entry.rpcComments[0].updatedAt;
                    _this.entry.todayCommentsCount = _this.entry.rpcComments.length;
                    _this.entry.rpcComments.forEach(function (horseRpc) {
                        _this.eventsService.changeCommentsData({ section: 'horseComments', result: horseRpc });
                    });
                }
                // Process non-RPCs
                if (_this.entry.comments.length) {
                    _this.entry.comments.forEach(function (horseComment) {
                        _this.eventsService.changeCommentsData({ section: 'horseComments', result: horseComment });
                    });
                }
                _this.meta.todayComments.loading = false;
            }, function (err) {
                _this.notification.error("Could't get " + _this.entry.horseName + " comments: " + _this.eventsService.getApiErrorMessage(err), 'Error!');
                _this.meta.todayComments.loading = false;
            });
        };
        this.openAddEnquiry = function (entry) {
            var possibleOffenders = [
                {
                    id: entry.horseId,
                    knownAs: entry.horseName,
                    type: 'horse'
                },
                {
                    id: entry.jockeyId,
                    knownAs: entry.jockeyKnownAs,
                    type: 'jockey',
                    jockeyMasterId: entry.jockeyMasterId,
                    jockeyMasterName: entry.jockeyMasterName,
                    jockeyMasterInvolved: false
                },
                {
                    id: entry.trainerId,
                    knownAs: entry.trainerKnownAs,
                    type: 'trainer'
                },
                {
                    id: entry.ownerId,
                    knownAs: entry.ownerKnownAs,
                    type: 'owner'
                }
            ];
            var enquiry = {
                meta: { year: entry.year, raceId: entry.raceId, divisionSequence: entry.divisionSequence, horseId: entry.horseId },
                race: { dateTime: entry.raceDateTime },
                offender: possibleOffenders[1] // jockey by default as it's the most common
            };
            var modalWindow = _this.modalService
                .open(AddEditEnquiryComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.enquiry = enquiry;
            modalWindow.componentInstance.possibleOffenders = possibleOffenders;
            modalWindow.result.then(function (result) {
                _this.entry.mostRecentEnquiryText = result.offence.offence;
                _this.entry.mostRecentEnquiryDate = result.racedate || result.date;
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
        this.openAddComment = function (entry) {
            var possibleSubjects = [
                {
                    id: entry.horseId,
                    knownAs: entry.horseName,
                    type: 'horse'
                },
                {
                    id: entry.jockeyId,
                    knownAs: entry.jockeyKnownAs,
                    type: 'jockey'
                },
                {
                    id: entry.trainerId,
                    knownAs: entry.trainerKnownAs,
                    type: 'trainer'
                },
                {
                    id: entry.ownerId,
                    knownAs: entry.ownerKnownAs,
                    type: 'owner'
                }
            ];
            var comment = {
                subject: possibleSubjects[0],
                entry: {
                    year: entry.year,
                    raceId: entry.raceId,
                    divisionSequence: entry.divisionSequence,
                    horseId: entry.horseId
                }
            };
            var modalWindow = _this.modalService.open(AddEditCommentComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.comment = comment;
            modalWindow.componentInstance.possibleSubjects = possibleSubjects;
            modalWindow.result.then(function (result) {
                if (result.rpcComments && result.rpcComments.length) {
                    _this.entry.todayCommentText = result.rpcComments.map(function (rpcComment) { return rpcComment.racePerformanceComment; }).join(', ');
                    _this.entry.todayCommentDate = result.updatedAt;
                    _this.entry.todayCommentsCount = _this.entry.todayCommentsCount ? _this.entry.todayCommentsCount + 1 : 1;
                }
                _this.eventsService.changeCommentsData({ section: 'horseComments', result: result });
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
        this.openRequestSampling = function (entry) {
            var modalWindow = _this.modalService.open(EntrySamplingRequestComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.entry = entry;
            modalWindow.result.then(function (result) {
                if (result.horseId) {
                    _this.entry.indicators.hasBeenSelectedForSampling = true;
                    _this.entry.samplingId = result.samplingId;
                }
                else {
                    _this.entry.indicators.hasBeenSelectedForSampling = false;
                    _this.entry.samplingId = null;
                }
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
        this.openChangeJockey = function (entry) {
            var modalWindow = _this.modalService.open(EntryJockeyChangeComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.entry = entry;
            modalWindow.result.then(function (result) {
                console.log("[ DEBUG ] Modal returned value:", result);
                var last = entry.jockeyChangeHistory.length - 1;
                entry.jockeyChangeHistory[last].comment = result.comment;
                entry.jockeyChangeHistory[last].internalComment = result.internalComment;
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
        this.openChangeJockeyHistory = function (entry) {
            var modalWindow = _this.modalService.open(JockeyChangeHistoryComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.entry = entry;
            modalWindow.result.then(function (result) {
                // console.log(`[ DEBUG ] Modal returned value:`, result);
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
        this.openNonRunner = function (entry) {
            var modalWindow = _this.modalService.open(EntryNonRunnerComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.entry = entry;
            modalWindow.result.then(function (result) {
                // console.log(`[ DEBUG ] Modal returned value:`, result);
                _this.entry.nonRunnerDeclaredDate = moment(result.declaredAt).format('YYYY-MM-DD');
                _this.entry.nonRunnerDeclaredTime = moment(result.declaredAt).format('HH:mm:ss');
                _this.entry.nonRunnerDeclaredReason = result.reasonText;
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
        this.openWithdrawn = function (entry) {
            var modalWindow = _this.modalService.open(EntryWithdrawnComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.entry = entry;
            modalWindow.result.then(function (result) {
                // console.log(`[ DEBUG ] Modal returned value:`, result);
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
    }
    RaceEntryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.meta = {
            raceDate: moment(this.entry.raceDateTime).format('YYYYMMDD'),
            loading: false,
            saving: false,
            previousRpcComment: {
                loading: false,
                saving: false
            },
            todayComments: {
                loading: false,
                saving: false
            },
            previousEnquiry: {
                loading: false,
                saving: false
            }
        };
        this.entry.shortDispensation = this.entry.dispensation
            ? this.entry.shoesDispensation.dispensation.split(' ').splice(0, 4).join(' ')
            : null;
        if (this.actions && Object.keys(this.actions).length) {
            this.enabledActions = this.actions;
        }
        this.eventsService.observableReveal.subscribe(function (enabled) {
            _this.reveal = enabled;
        });
        this.loadOldComments(this.entry.horseId);
        this.loadOldEnquiries(this.entry.horseId);
        this.loadTodayComments(this.entry.horseId);
        // console.log('Entry:', this.entry);
    };
    RaceEntryComponent.prototype.debugShowMe = function (entry) {
        console.log('Clicked on entry:', entry);
    };
    RaceEntryComponent.prototype.getNonFinishingDescription = function (nonFinishingCode) {
        var descriptionMap = {
            1: 'Pulled Up',
            2: 'Fell',
            3: 'Unseated Rider',
            4: 'Ran Out',
            5: 'Refused',
            6: 'Brought Down',
            7: 'Carried Out',
            8: 'Slipped Up',
            9: 'Walkover',
            23: 'Refused to Run',
        };
        return descriptionMap[nonFinishingCode] || 'Unknown';
    };
    RaceEntryComponent.prototype.getPosition = function (entry) {
        return entry.positionCos || entry.positionPfo || entry.positionJudges || null;
    };
    Object.defineProperty(RaceEntryComponent.prototype, "courseDeclarationLines", {
        get: function () {
            var declarations = this.entry && this.entry.courseDeclarations;
            if (!declarations) {
                return [];
            }
            var lines = COURSE_DECLARATION_LABELS
                .filter(function (label) { return !!declarations[label.key]; })
                .map(function (label) { return ({ text: label.description, isFreeText: false }); });
            var privilegeText = (declarations.privilegeText || '').trim();
            if (privilegeText) {
                lines.push({ text: privilegeText, isFreeText: true });
            }
            var specialRequirementsText = (declarations.specialRequirementsText || '').trim();
            if (specialRequirementsText) {
                lines.push({ text: specialRequirementsText, isFreeText: true });
            }
            return lines;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RaceEntryComponent.prototype, "hasCourseDeclarations", {
        get: function () {
            return this.courseDeclarationLines.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    RaceEntryComponent.prototype.truncateText = function (text, limit) {
        if (limit === void 0) { limit = 30; }
        if (!text || text.length <= limit) {
            return text;
        }
        return text.slice(0, limit);
    };
    RaceEntryComponent.prototype.isTextTruncated = function (text, limit) {
        if (limit === void 0) { limit = 30; }
        return !!(text && text.length > limit);
    };
    RaceEntryComponent.prototype.openFullText = function (content, text, title) {
        if (title === void 0) { title = 'Raceday Privilege'; }
        this.fullTextModalTitle = title;
        this.fullTextModalBody = text;
        this.modalService.open(content, { centered: true, size: 'lg' });
    };
    return RaceEntryComponent;
}());
export { RaceEntryComponent };
